export class ResponseServicio {
    idResultado: number;
    resultado: string;
    value: string;
    values: InformacionServicio;
    list: ConductorAsignado[];

    constructor(){
    this.idResultado= 0;
    this.resultado= "";
    this.value = ""; 
        this.values = {};
    }
}

export type InformacionServicio = {
  // Keys fijas conocidas (opcionales)
  DISTANCIA_RECORRIDA?: string;
  INTERVALO_CONTADOR?: string;
  CLIENTE_CONTADOR?: string;
  CANTIDAD_CONDUCTOR_ENCONTRADO?: string;
  CONDUCTOR_CONTADOR?: string;
  conductoractual?: string;
  IdServicio?: string;
  conductoresnotificados?: string;
  conductoresexcluidos?: string;
  ultimaConsulta?: number;
  idservicio?: string;

  // Cualquier key dinámica que venga del backend
  [key: string]: string | number | undefined;
};


export class ConductorAsignado{
    aireAcondicionado: boolean;
    color: string;
    distancia: number;
    distrito: string;
    estado: string;
    estadoServicio: number;
    fechaFabricacion: number;
    idConductor: string;
    idDestino: number;
    idMovil: string;
    idResultado: number;
    idServicio: number;
    latitudConductor: number;
    longitudConductor: number;
    maleteraAmplia: boolean;
    nombreCompleto: string;
    placa: string;
    rating: number;
    resultado: string;
    tInicio: number;
    telefonoMovil: string;
    tiempo: number;
    tipovehiculo: string;


    constructor(){

    }
}

